<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <v-container
    id="data-tables"
    class="fill-height align-start"
    fluid
    tag="section"
  >
    <v-container
      fluid
    >
      <ik-data-table
        entity-name="TaxSetting"
        :model="model"
        :use-delete-action="false"
        icon="mdi-cash-usd"
      />
    </v-container>
  </v-container>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import Tax from '@/model/dataLayer/api/export/Tax'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      model: Tax
    })
  }
}
</script>
